import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  h1 {
    font-size: 2rem;
  }

  p {
    font-size: 1.5rem;
    margin-bottom: 1rem;
  }

  button {
    padding: 10px 20px;
    font-size: 1rem;
    cursor: pointer;
  }
`;

export const Logo = styled.img`
  width: 80px;
  height: auto;
`;

export const Button = styled.button`
  background-color: #2f6fed80;
  color: #fff;
  border: none;
  border-radius: 4px;
  padding: 10px 20px;
  font-size: 1rem;
  cursor: pointer;
  transition: 0.2s;

  &:hover {
    background-color: rgba(47, 111, 237, 0.5);
  }
`;
